module.exports = __webpack_public_path__ + "static/media/LandingPage-Xchange.1cdd93f9.png";